module.exports = __webpack_public_path__ + "logo-header.a29827ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/logo-header.png
// module id = 86og
// module chunks = 0